import { OnInit, AfterViewInit, Component, Input } from "@angular/core";
import { ConfigModel, OpsMonthConfigModel } from '../../../../models/graphs.model';
import { Observable } from "rxjs";
import { GraphService } from '../../../../services/graphs.service';

@Component({
    selector: 'app-ops-onshore-offshore-production-type',
    templateUrl: './onshoreOffshoreProdType.component.html',
    styleUrls: ['../../home/home.component.scss']
})

export class OnshoreOffshoreProdTypeComponent implements OnInit, AfterViewInit {

    @Input() ops_CurrentMonth: number;
    @Input() ops_CurrentYear: number;
    @Input() ops_ProdType_Domgas: number;
    @Input() ops_ProdType_Liquids: number;
    @Input() ops_ProdType_LNG: number;
    @Input() ops_ProdType_Max: number;
    @Input() ops_CurrentMonthName: string;

    opsChart: object;
    graphService: Observable<any>;
    monthService: Observable<any>;
    graphData: ConfigModel = new ConfigModel();
    monthData: OpsMonthConfigModel = new OpsMonthConfigModel();
    
    constructor(private graph: GraphService) { 
        this.graphData = new ConfigModel();
        this.monthService = this.graph.getOpsMonth();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.load();
        })
    }

    ngOnInit(): void {
    }

    load() {

        this.graphService = this.graph.getConfig();
        this.graphService.subscribe(data => {

            this.graphData = data.contents;
            this.monthService.subscribe(data => {
                this.monthData = data.contents;
                this.ops_CurrentMonthName = this.monthData.currentMonthName;
                this.opsType();
            });
            
        });
    }

    refresh() {

        this.graphData.ops_ProdType_Domgas = this.ops_ProdType_Domgas;
        this.graphData.ops_ProdType_Liquids = this.ops_ProdType_Liquids;
        this.graphData.ops_ProdType_LNG = this.ops_ProdType_LNG;
        this.graphData.ops_ProdType_Max = this.ops_ProdType_Max;

        var x1 = this.graphData.ops_ProdType_Domgas;
        var y1: number = +x1;
        this.graphData.ops_ProdType_Domgas = y1;

        var x2 = this.graphData.ops_ProdType_Liquids;
        var y2: number = +x2;
        this.graphData.ops_ProdType_Liquids = y2;

        var x3 = this.graphData.ops_ProdType_LNG;
        var y3: number = +x3;
        this.graphData.ops_ProdType_LNG = y3;

        var x4 = this.graphData.ops_ProdType_Max;
        var y4: number = +x4;
        this.graphData.ops_ProdType_Max = y4;

        this.opsType();
    }

    opsType() {

        this.opsChart = {
            credits: {
                enabled: false
            },
            exporting: { enabled: false },
            chart: {
                type: "column",
                width: null,
                style: {
                    fontFamily: "Verdana",
                    color: "#333",
                    fontSize: "12px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                },
                backgroundColor: "#fff",
                plotBorderWidth: 0,
                plotBackgroundColor: "#ffffff",
            },
            tooltip: {
                enabled: false
            },

            title: {
                text: 'Production Volumes',
                style: {
                    fontFamily: "Verdana",
                    color: "#333333",
                    fontSize: "18px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            subtitle: {
                text: 'Avg. daily production for ' + this.ops_CurrentMonthName + ' ' + this.graphData.ops_CurrentYear,
                style: {
                    fontFamily: "Verdana",
                    color: "#666666",
                    fontSize: "14px",
                    fontWeight: "normal",
                    fontStyle: "normal"
                }
            },
            xAxis: {
                type: "category",
                allowDecimals: false,
                tickInterval: 1,
                labels: {
                    enabled: true,
                },
                tickPosition: 'inside',
                crosshair: true,
                index: 0,
                isX: true,
                title: {
                    style: {
                        fontFamily: "Verdana",
                        color: "#666666",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            },
            yAxis: [{
                title: {
                    text: 'kboe/day',
                    style: {
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: "normal",
                        fontStyle: "normal"
                    }
                },
                min: 0,
                max: this.graphData.ops_ProdType_Max,
                tickInterval: 10,
                minorTickInterval: 0,
                majorTickInterval: 0,
                labels: {
                    formatter: function () {
                        return ' '
                    }
                },
                gridLineWidth: 0,
                stackLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'gray'
                    }
                }
            }
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: false,
                        format: '{point.y}'
                    },
                    stacking: 'normal'
                }
            },

            series: [{
                data: [{ name: 'Gas', y: this.graphData.ops_ProdType_Domgas }],
                showInLegend: false,
            }, {
                data: [{ name: 'Liquids', y: this.graphData.ops_ProdType_Liquids }],
                showInLegend: false,
            }, {
                data: [{ name: 'LNG', y: this.graphData.ops_ProdType_LNG }],
                showInLegend: false,
            }],
            colors: ["#85b1d3", "#b6c8d6", "#85b1d3"]
        };
    }

    /********************************************************
            Utils
    *********************************************************/
    // getDateForDisplay(month: number, year: number): string {
    //     var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    //     var retVal: string = months[month - 1];
    //     retVal += ' ' + year;
    //     return retVal;
    // }
}